function parse(address) {
  try {
    return new URL(address);
  } catch (err) {
    return null;
  }
}

function currentOrigin() {
  return typeof window === 'undefined' ? undefined : window.location.origin;
}

function isWebSubdomain(candidate, web, environment) {
  const domain = environment.VITE_CREDERE_WEB_DOMAIN;

  if (!domain || candidate.protocol !== web.protocol || candidate.port !== web.port) {
    return false;
  }

  const [label, ...rest] = candidate.hostname.split('.');

  return rest.join('.') === domain && /^[a-z0-9-]+$/.test(label);
}

// The web answers on its own host and, when VITE_CREDERE_WEB_DOMAIN is set, on any single-label
// subdomain of it; the embed's own host is a subdomain that is not the web.
export function isWebOrigin(origin, environment = import.meta.env) {
  const web = parse(environment.VITE_CREDERE_WEB_HOST);
  const candidate = parse(origin);

  if (!web || !candidate) {
    return false;
  }

  if (candidate.origin === web.origin) {
    return true;
  }

  if (candidate.origin === environment.VITE_CREDERE_EMBED_HOST) {
    return false;
  }

  return isWebSubdomain(candidate, web, environment);
}

// Where this app may run inline trusting the page's `window.CREDERE`.
export function isInternalOrigin(origin, environment = import.meta.env) {
  return isWebOrigin(origin, environment)
    || (!!environment.VITE_CREDERE_TUNNEL_HOST && origin === environment.VITE_CREDERE_TUNNEL_HOST);
}

// The address of the web for links the user takes away: the one they are on, when it is the web.
export function webHost(origin = currentOrigin(), environment = import.meta.env) {
  return isWebOrigin(origin, environment) ? origin : environment.VITE_CREDERE_WEB_HOST;
}
